import React from 'react';
import { Section } from './Section';
import { XCircle } from 'lucide-react';
export function WhyItFailedSection() {
  const failures = ['Los jugos detox comerciales están llenos de azúcar que inflama tu intestino instantáneamente.', 'Las dietas de "cero carbohidratos" disparan tu ansiedad y te hacen retener más líquidos por el rebote hormonal.', 'Los suplementos "quemagrasa" suelen ser estimulantes que alteran tu sueño y empeoran la hinchazón por la mañana.', 'Intentar "comer sano" sin entender cómo funcionan los ingredientes procesados en USA es una batalla perdida.'];
  return <Section className="bg-cream" data-id="element-134">
      <h2 className="font-serif text-3xl md:text-4xl text-forest font-bold mb-10 text-center" data-id="element-135">
        Por qué lo que has intentado no funcionó
      </h2>
      <div className="space-y-6" data-id="element-136">
        {failures.map((text, index) => <div key={index} className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm border border-cream-dark" data-id="element-137">
            <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-138" />
            <p className="text-gray-700 text-lg" data-id="element-139">{text}</p>
          </div>)}
      </div>
    </Section>;
}